import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {NgbDatepickerConfig, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  preserveWhitespaces: false
})
export class DateInputComponent  implements OnInit {
  model;
  @Input() date: string;
  @Input() isDisable: boolean;
  @Input() showIcon: boolean;
  @Input() hasDanger: boolean;
  @Input() dateInputOptions: any = {
    id: null,
    name: null,
    placeholder: null,
    minDate: null,
    maxDate: null,
    outsideDays: false,
    weekendsDisable: false
  };
  @Output() dateChanged = new EventEmitter<any>();
  public datepickerConfig: any;

  constructor(config: NgbDatepickerConfig) {
    this.datepickerConfig = config;
  }

  setDatepicker() {
    const config = this.datepickerConfig;
    const options = this.dateInputOptions;
    if (options.outsideDays) {
      config.outsideDays = 'hidden';
    }
    if (options.weekendsDisable) {
      config.markDisabled = (date: NgbDateStruct) => {
        const d = new Date(date.year, date.month - 1, date.day);
        return d.getDay() === 0 || d.getDay() === 6;
      };
    }
  }

  ngOnInit() {
    this.setDatepicker();
  }

  @Input('date')
  set value(date: string) {
    this.model = date ? date : '';
    this.model = this.dateConvert(this.model, true);
  }

  dateConvert(date: any, flag: boolean) {
    if (flag) {
      // Input
      if (!moment(date, 'YYYY-MM-DD').isValid()) {
        return false;
      }
      const m = moment(date);
      const obj = m.toObject();
      return { year: obj.years, month: obj.months + 1, day: obj.date };
    } else {
      date.month -= 1;
      return moment(date).format();
    }
  }

  changeFields() {
    const val = this.dateConvert(this.model, false);
    this.dateChanged.emit(val);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/date-input/date-input.component.ts